var map = {
	"./Alarm Systems.svg": 51714,
	"./Amplifier.svg": 62591,
	"./Awnings.svg": 2028,
	"./Battery Status.svg": 68376,
	"./Ceiling Spotlights.svg": 31875,
	"./Chandelier.svg": 50643,
	"./Climate.svg": 33154,
	"./Coffee Makers.svg": 83821,
	"./Cold Water.svg": 59241,
	"./Computer.svg": 71542,
	"./Consumption.svg": 49938,
	"./Curtains.svg": 96730,
	"./Dishwashers.svg": 96668,
	"./Doors.svg": 19925,
	"./Doorstep.svg": 15760,
	"./Dryer.svg": 27951,
	"./Fan.svg": 35624,
	"./Floor Lamps.svg": 6724,
	"./Garage Doors.svg": 41692,
	"./Gates.svg": 12654,
	"./Hairdryer.svg": 51149,
	"./Handle.svg": 9183,
	"./Hanging Lamps.svg": 38554,
	"./Heater.svg": 20780,
	"./Hoods.svg": 78909,
	"./Hot Water.svg": 78962,
	"./Humidity.svg": 43461,
	"./Iron.svg": 18534,
	"./Irrigation.svg": 42013,
	"./Led Strip.svg": 65002,
	"./Light.svg": 47462,
	"./Lightings.svg": 67129,
	"./Lock.svg": 18221,
	"./Louvre.svg": 95571,
	"./Mowing Machine.svg": 57447,
	"./Music.svg": 86218,
	"./Outdoor Blinds.svg": 19417,
	"./People.svg": 89251,
	"./Pool.svg": 48493,
	"./Power Consumption.svg": 8376,
	"./Printer.svg": 93291,
	"./Pump.svg": 27568,
	"./Receiver.svg": 19796,
	"./Sconces.svg": 96585,
	"./Security.svg": 88250,
	"./Shading.svg": 6672,
	"./Shutters.svg": 87329,
	"./SmokeDetector.svg": 9950,
	"./Sockets.svg": 80993,
	"./Speaker.svg": 12265,
	"./Stove.svg": 23523,
	"./Table Lamps.svg": 79717,
	"./Temperature Sensors.svg": 3735,
	"./Tv.svg": 59392,
	"./Vacuum Cleaner.svg": 79597,
	"./Ventilation.svg": 17948,
	"./Washing Machines.svg": 50603,
	"./Water Consumption.svg": 35306,
	"./Water Heater.svg": 21219,
	"./Water.svg": 65028,
	"./Weather.svg": 99158,
	"./Window.svg": 81640,
	"./list": 95605,
	"./list.json": 95605,
	"./names.txt": 62354,
	"./parseNames": 38852,
	"./parseNames.d.ts": 74250,
	"./parseNames.js": 38852
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29673;